module.exports = __webpack_public_path__ + "img/00044.32f941e5.webp";